module.exports = __webpack_public_path__ + "img/hamburger-menu.851481b3.svg";